export const Roles = Object.freeze({
    Admin: 'Admin',
    Capturer: 'Capturer',
    Champion: 'Champion',
    Readonly: 'Readonly',
    Developer: 'Developer',
});
